<template>
	<app-section class="max-w-xl mx-auto">
		<app-select
			id="categoriesSelect"
			ref="categoriesSelect"
			mode="tags"
			:object="true"
			:delay="500"
			:minChars="3"
			:resolveOnLoad="true"
			:options="async (q) => await getTemplateCategories(q)"
			:searchable="true"
			placeholder="Add Categories"
			:loading="loadingCategories"
			v-model="selectedCategories"
		/>
		<div v-if="!loadingCategories && !categories.length && selectedCategory.categoryName" class="text-center mt-8">
			<p>
				There is no category for "<b>{{ selectedCategory.categoryName }}".</b> Do you want to create it?
			</p>
			<app-button class="btn btn-info small mx-auto mt-2" icon="plus" @click="newOption">
				Add New Category
			</app-button>
		</div>
		<app-button class="btn btn-success ml-auto mt-2 px-12" :loading="loading" @click="submit">
			Save
		</app-button>

		<menu-category-modal
			v-if="showCategoryModal"
			:show="showCategoryModal"
			@close="showCategoryModal = false"
			:category="selectedCategory"
			@created="onCategoryCreated"
		/>
	</app-section>
</template>

<script>
	import CategoriesService from '@/services/sales/CategoriesService';
	import MenuCategoryModal from '@/components/categories/MenuCategoryModal';

	export default {
		name: 'CategoriesSection',
		components: { MenuCategoryModal },
		props: {
			currentCategories: {
				type: Array,
				default: () => [],
			},
			loading: {
				type: Boolean,
				default: false,
			},
		},
		data: () => ({
			loadingCategories: false,
			selectedCategories: [],
			categories: [],
			selectedCategory: {
				categoryName: null,
			},
			showCategoryModal: false,
		}),
		methods: {
			getTemplateCategories(userSearch = '') {
				this.selectedCategory.categoryName = userSearch;
				this.loadingCategories = true;
				let filters = { limit: 10, offset: -1, status: 1, userSearch };
				return CategoriesService.menuCategories(filters)
					.then((res) => {
						this.categories = res;
						return res;
					})
					.catch((e) => {
						this.$notificationService.error(e);
					})
					.finally(() => {
						this.emitter.emit('isLoading', false);
						this.loadingCategories = false;
					});
			},
			onCategoryCreated(category) {
				this.selectedCategories.push({ ...category, label: category.categoryName, value: category.id });
				this.selectedCategory.categoryName = null;
				this.showCategoryModal = false;
			},
			submit() {
				this.$emit('submit', this.selectedCategories);
			},
			newOption() {
				this.showCategoryModal = true;
			},
		},
		mounted() {
			this.getTemplateCategories();
			this.selectedCategories = this.currentCategories
				.filter((cat) => cat.id !== -30)
				.map((cat) => ({
					id: cat.menuCategory.id,
					label: cat.menuCategory.categoryName,
					value: cat.menuCategory.id,
				}));
		},
	};
</script>

<style scoped></style>
